
    <div class="panel-wrapper">
      <div class="panel-header" *ngIf="to.label || to.description">
        <h2 class="panel-title" *ngIf="to.label">{{ to.label }}</h2>
        <p class="panel-description" *ngIf="to.description">{{ to.description }}</p>
      </div>
      <div class="panel-content">
        <ng-container #fieldComponent></ng-container>
      </div>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/views/challenge/panel-wrapper/panel-wrapper.component.ts.PanelWrapperComponent.html